import { Button } from "../ui/button";
import { IoIosArrowBack } from "react-icons/io";
import { Input } from "../ui/input";
import { Field, Form } from "react-final-form";
import { renderField, composeValidators, required, email, preventNonNumericAndRestrictLength, characterLimit, preventNonNumericAndRestrictDecimal } from "../../helpers/form-validations";
import { Label } from "../ui/label";
import { Card } from "../ui/card";

import React, { useEffect, useState } from 'react'
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu"
import { meta } from 'eslint-plugin-prettier'
import { IoIosArrowDown } from 'react-icons/io'
import { MdHorizontalRule } from "react-icons/md";
import { useNavigate, useSearchParams } from "react-router-dom";
import { DatePicker } from "../ui/date-picker";
import { createScheme, EditScheme, getSchemesDropdown } from "../../utils/util";
import DynamicInputFields from "../ui/dynamic-input";
import AdvancedDropdown from "../ui/multi-selection-dropdown-menu-with-search";
import { useDispatch, useSelector } from "react-redux";
import { loaderSet } from "../../context/actions/loaderAction";
import { alertDanger, alertSuccess } from "../../context/actions/toastAction";
import { nullSchemeInfo } from "../../context/actions/schemeInfoAction";
import Loader from "../loader";
import { setAllSchemeDetails } from "../../context/actions/allSchemeDetailsAction";
import { IndianRupee } from "lucide-react";

function NewSchemaForm({ back,getAllScheme ,forWhichUserType}) {
const navigate=useNavigate()
const [searchParams] = useSearchParams();
const schemeInfo=useSelector(state=>state.schemeInfo)
const dispatch=useDispatch()
const schemeId = searchParams.get('scheme_id');
const actionType = searchParams.get('action_type');
const [fieldsData, setFieldsData] = useState(schemeInfo && schemeInfo?.fund_manager.length>0 ? schemeInfo?.fund_manager.map(fund=>fund) :[]);
const [isLoading,setIsLoading]=useState(false)
useEffect(() => {
  console.log('SChemeID ID:', schemeId);
  console.log('Action Type:', actionType);
  // You can use these values as needed, for example, making API calls
  console.log("from redux scheme Info",schemeInfo)
  dispatch(loaderSet(false))
}, [schemeId, actionType]);
  const [addNewClass,setAddNewClass] = useState(false)

  // const [classArray, setClassArray] = useState([]);
 const [fundManagerArray,setFundManagerArray]=useState([])
  // useEffect(() => {
  //   if (schemeInfo?.scheme_class?.length > 0) {
  //     setClassArray(schemeInfo.scheme_class);
  //   }
  // }, [schemeInfo]);
  // This function will be passed to DynamicInputFields to capture the changes
  // const handleFieldsChange = (newValues) => {
  //   setFundManagerArray(newValues);
  // };

  const handleFieldsChange = (inputFields, imageFile) => {
    setFieldsData(inputFields); // Set the input field values
    
  };


  const getAllSchemeDetailsForSchemeDropdown=async()=>{
    try {
      const response =await getSchemesDropdown()
      console.log("response for gett all schemes dropdown from admin index.js file ",response.data)
      if(response){
        dispatch(setAllSchemeDetails(response?.data));
      }
    } catch (error) {
      console.log("Error in get all schemes dropdown ",error)
    }
  }


  const onSubmit = async(values) => {
    console.log("Fields Data:", fieldsData);
    setIsLoading(true)
    const payload={
      scheme_id:schemeId && schemeId,
      "scheme_name": values?.schemeName || schemeInfo?.scheme_name  ,
      "scheme_class":values?.schemeClass || schemeInfo?.scheme_class,
      "launch_date":values?.launch_date || schemeInfo?.launch_date ,
      "fund_tenure":values?.fundTenure || schemeInfo?.fund_tenure ,
      "minimum_investment":values?.minimum_investment || schemeInfo?.minimum_investment ,
      "aum": values?.aum || schemeInfo?.aum ,
      "nav":values?.nav || schemeInfo?.nav ,
      "as_on_date": values?.as_on_date || schemeInfo?.as_on_date,
      // "email_id": "fundmanager@example.com",
      "scheme_description":values?.scheme_description || schemeInfo?.scheme_description,
      "benchmark":(selectedOptions?.length>0 && selectedOptions[0]) || schemeInfo?.benchmark,
      "mobile_number": values?.mobile || schemeInfo?.mobile_number ,
      // "fund_manager":fieldsData &&  fieldsData || fundManagerArray.filter(curElem=>curElem!=="")
      "fund_manager":fieldsData && fieldsData,
      no_of_units_issued:schemeInfo && schemeInfo?.no_of_units_issued ? schemeInfo?.no_of_units_issued:"0",
      face_value:values?.face_value || schemeInfo?.face_value
    }
    try {
      if(actionType==="Edit"){
        const response=await EditScheme(payload)
        console.log("response for scheme",response)
        if(response && response?.code===200)
        {

          dispatch(alertSuccess("Scheme Edited Succesfully"))
          if(forWhichUserType==="employee"){
           
            navigate("/employee")
          }
          if(forWhichUserType==="admin"){
            
            navigate("/admin")
          }
  
          getAllSchemeDetailsForSchemeDropdown()
          getAllScheme()
          dispatch(nullSchemeInfo())

          setIsLoading(false)
          return
        }
        else{
          dispatch(alertDanger(response?.message))
          setIsLoading(false)
          return
        }
       
      }
      const response=await createScheme(payload)
      console.log("response for scheme",response)
      if(response.code===200){
        dispatch(alertSuccess("Successfully created Scheme"))
        // dispatch(sche)
        back()
        dispatch(nullSchemeInfo())
        getAllSchemeDetailsForSchemeDropdown()
        getAllScheme()
        setIsLoading(false)
        return
      }
      else{
        // dispatch(alertDanger("Scheme already exists"))
        dispatch(alertDanger(response?.message))
        setIsLoading(false)
        return
      }
    
      
    } catch (error) {
      dispatch(alertDanger("Internal Server Error"))
      console.log("error in craete scheme",error)
      // dispatch(loaderSet(false))
      setIsLoading(false)

    }
  }

 

// useEffect(()=>{
//  console.log("add new class",classArray.filter(curElem=>curElem!==""))
// },[classArray])


const [selectedOptions, setSelectedOptions] = useState( schemeInfo && schemeInfo.benchmark ? [schemeInfo.benchmark] :[]);
  const benchMarkOptions = ['BSE500','NSE500','NIFTY50','NIFTYSMALLCAP250','NIFTYMIDCAP100','BANKNIFTY','NIFTYIT','NIFTY200'];

  return (
    <Card className="p-3">
{
        isLoading && <Loader/>
      }

      {/* Back Button */}
      { actionType!=="View" && <Button
        variant="outline"
        size="sm"
        className="h-7 gap-1 text-sm w-max"
        onClick={()=>{
          if(forWhichUserType==="employee"){
            navigate("/employee")
          }
          if(forWhichUserType==="admin"){
            navigate("/admin")
          }
          dispatch(nullSchemeInfo())
          back()
        }
        } 
      >
        <IoIosArrowBack />
        Back
      </Button>}


      <Form
        onSubmit={onSubmit}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>

            <div className="w-full flex flex-col p-6 mb-6 bg-[#FFFFFF] rounded-md gap-8">

              <div className="flex w-full justify-between items-center gap-6 ">

                {/* Scheme name Input field */}

                <div className="gap-2 flex flex-col w-[49%]">
                  <Label className="text-start text-[#0D215C] font-bold text-lg " htmlFor="schemeName">Scheme Name <span className=" text-red-600">*</span> </Label>
                  <Field
                    id="schemeName"
                    type="text"
                    name="schemeName"
                    placeholder="Scheme Name"
                    actionType={actionType}
                    info={schemeInfo && schemeInfo.scheme_name}
                    disabled={(actionType==="View" || actionType==="Edit" )&& true}
                     validate={
                         (actionType !== "Edit" && actionType!=="View") ? composeValidators(required) : undefined  
                       }   component={renderField} // Correct usage of renderField
                    className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                  />
                  {/* Reserve space for the error message */}
                  {meta.touched && meta.error && (
                    <p className="text-red-500 text-sm text-left my-[2px]">&nbsp;{meta.error}</p>
                  )}
                </div>

                <div className="gap-2 flex flex-col w-[49%]">
                  <Label className="text-start text-[#0D215C] font-bold text-lg " htmlFor="schemeClass">Scheme Class <span className=" text-red-600">*</span> </Label>
                  <Field
                    id="schemeClass"
                    type="text"
                    name="schemeClass"
                    placeholder="Scheme Class"
                    actionType={actionType}
                    info={schemeInfo && schemeInfo.scheme_class}
                    disabled={(actionType==="View" || actionType==="Edit" ) && true}
                      validate={
                          (actionType !== "Edit" && actionType!=="View") ? composeValidators(required) : undefined  
                        }     component={renderField} // Correct usage of renderField
                    className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                  />
                  {/* Reserve space for the error message */}
                  {meta.touched && meta.error && (
                    <p className="text-red-500 text-sm text-left my-[2px]">&nbsp;{meta.error}</p>
                  )}
                </div>

              </div>
              <div className="flex w-full justify-between items-center gap-6 ">

{/* Scheme name Input field */}


<div className="gap-2 flex flex-col w-[49%]">
  <Label className="text-start text-[#0D215C] font-bold text-lg " htmlFor="inceptionDate">Launch Date <span className=" text-red-600">*</span> </Label>
  <Field
    id="launch_date"
  
    name="launch_date"
    // placeholder="Scheme Name"
    //  validate={
    //      (actionType !== "Edit" && actionType!=="View") ? composeValidators(required) : undefined  
    //    } 
    component={DatePicker} // Correct usage of renderField
    disabled={actionType==="View"}
    initialValue={ schemeInfo && schemeInfo?.launch_date}
    className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
  />
</div>
<div className="gap-2 flex flex-col w-[49%]">
                  <Label className="text-start  text-[#0D215C] font-bold text-lg " htmlFor="fundTenure">Scheme Tenure <span className=" text-red-600">*</span> </Label>
                  <Field
                    id="fundTenure"
                    type="text"
                    name="fundTenure"
                    placeholder="Fund Tenure"
                    // onKeyDown={(event) => preventNonNumericAndRestrictLength(event)}
                    actionType={actionType}
                    info={schemeInfo && schemeInfo.fund_tenure}
                    disabled={actionType==="View" && true}
                     validate={
                         (actionType !== "Edit" && actionType!=="View") ? composeValidators(required,characterLimit(100)) : undefined  
                       } 
                    component={renderField} // Correct usage of renderField
                    className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                  />
                  {/* Reserve space for the error message */}
              
      {meta.touched && meta.error && (
        <p className="text-red-500 text-sm text-left my-[2px]">{meta.error}</p>
      )}
  
                </div>

</div>

<div className="flex w-full justify-between items-center gap-6 ">

{/* Fund Tenure Input field */}

<div className="gap-2 flex flex-col w-[49%]">
<Label className="text-start text-[#0D215C] font-bold text-lg " htmlFor="no_of_units_issued">No of Units issued 
  {/* <span className=" text-red-600">*</span> */}
   </Label>
<Field
id="no_of_units_issued"
type="text"
name="no_of_units_issued"
placeholder="No of units issued"
actionType={actionType}
info={schemeInfo && schemeInfo.no_of_units_issued?Number(schemeInfo.no_of_units_issued).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }):null}
// disabled={actionType==="View" && true}
disabled
// validate={
// (actionType !== "Edit" && actionType!=="View") ? composeValidators(required) : undefined  
// } 
component={renderField} // Correct usage of renderField
className="bg-muted/40 h-10 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
/>
{/* Reserve space for the error message */}
{meta.touched && meta.error && (
<p className="text-red-500 text-sm text-left my-[2px]">&nbsp;{meta.error}</p>
)}
</div>
<div className="gap-4 w-[49%]">
<AdvancedDropdown
options={benchMarkOptions}
selectedOptions={selectedOptions}
setSelectedOptions={setSelectedOptions}
placeholder="Select One"
id="benchMark"
name="BenchMark"
select="single"
actionType={actionType}
disabled={actionType==="View"}
required={true}
/>
</div>


</div>
<div className="flex w-full justify-between items-center gap-6 ">


{/* Dropdown Menu */}

{/* <div className="gap-2 flex flex-col w-[49%]">
  <Label className="text-start text-[#0D215C] font-bold text-lg " htmlFor="aum">AUM<span className=" text-red-600">*</span> </Label>
  <Field
    id="aum"
    type="text"
    name="aum"
    placeholder="aum"
    actionType={actionType}
    info={schemeInfo && schemeInfo.aum}
    disabled={actionType==="View" && true}
    // validate={composeValidators(required)}
    onKeyDown={(event) => preventNonNumericAndRestrictLength(event)}
    component={renderField} // Correct usage of renderField
    className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
  />

  {meta.touched && meta.error && (
    <p className="text-red-500 text-sm text-left my-[2px]">&nbsp;{meta.error}</p>
  )}
</div> */}


<div className="gap-2 flex flex-col w-[49%]">
  <Label className="text-start text-[#0D215C] font-bold text-lg " htmlFor="face_value">Face Value / Unit (<span className="inline-block align-middle">
    <IndianRupee size={18} />
  </span>) <span className=" text-red-600">*</span> </Label>
  <Field
    id="face_value"
    type="text"
    name="face_value"
    placeholder="Face Value"
    onKeyDown={(event) => preventNonNumericAndRestrictDecimal(event)}
    actionType={actionType}
    info={schemeInfo && schemeInfo.face_value}
    disabled={actionType==="View" && true}
  validate={
      (actionType !== "Edit" && actionType!=="View") ? composeValidators(required) : undefined  
    } 
    component={renderField} // Correct usage of renderField
    className="bg-muted/40 h-10 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
  />
  {/* Reserve space for the error message */}
  {meta.touched && meta.error && (
    <p className="text-red-500 text-sm text-left my-[2px]">&nbsp;{meta.error}</p>
  )}
</div> 

<div className="flex flex-col gap-2 w-[49%]">
                  <Label className="text-start text-[#0D215C] font-bold text-lg " htmlFor="nav">NAV / Units as at end of Last Quarter <span className=" text-red-600">*</span> </Label>
                  <Field
                    id="nav"
                    name="nav"
                    placeholder="NAV"
                    type="text"
                    actionType={actionType}
                    info={schemeInfo && schemeInfo.nav}
                    disabled={actionType==="View" && true}
                   validate={
                       (actionType !== "Edit" && actionType!=="View") ? composeValidators(required) : undefined  
                     } 
                    onKeyDown={(event) => preventNonNumericAndRestrictDecimal(event)}
                    component={renderField} // Correct usage of renderField
                    className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss "
                  />
                  {/* Reserve space for the error message */}
                
      {meta.touched && meta.error && (
        <p className="text-red-500 text-sm  text-left my-[2px]">{meta.error}</p>
      )}
   
                </div>

{/* <div className="gap-2 flex flex-col w-[49%]">
  <Label className="text-start text-[#0D215C] font-bold text-lg " htmlFor="minimum_investment">Minimum Investment<span className=" text-red-600">*</span> </Label>
  <Field
    id="minimum_investment"
    type="text"
    name="minimum_investment"
    placeholder="Minimum Investment"
    onKeyDown={(event) => preventNonNumericAndRestrictLength(event)}
    actionType={actionType}
    info={schemeInfo && schemeInfo.minimum_investment}
    disabled={actionType==="View" && true}
    validate={
        (actionType !== "Edit" && actionType!=="View") ? composeValidators(required) : undefined  
      } 
    component={renderField} // Correct usage of renderField
    className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
  />

  {meta.touched && meta.error && (
    <p className="text-red-500 text-sm text-left my-[2px]">&nbsp;{meta.error}</p>
  )}
</div>  */}


</div>



           


<div className="flex w-full justify-between items-center gap-4 ">

<div className="gap-2 flex flex-col w-[49%]">
  <Label className="text-start text-[#0D215C] font-bold text-lg " htmlFor="as_on_date">As on Date </Label>
  <Field
    id="as_on_date"
  
    name="as_on_date"
    // placeholder="Scheme Name"
    // validate={composeValidators(required)}
    component={DatePicker} // Correct usage of renderField
    initialValue={ schemeInfo && schemeInfo?.as_on_date}
    disabled={actionType==="View"}
    className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
  />
</div>


      </div>

      <div className="flex w-full justify-between items-center gap-6 ">

{/* Fund Tenure Input field */}


<div className="gap-2 flex flex-col w-full">
                  <Label className="text-start text-[#0D215C] font-bold text-lg " htmlFor="scheme_description">Scheme Description<span className=" text-red-600">*</span> </Label>
                  <Field
                    id="scheme_description"
                    type="textarea"
                    name="scheme_description"
                    placeholder="Scheme Description"
                    actionType={actionType}
                    info={schemeInfo && schemeInfo.scheme_description}
                    disabled={actionType==="View" && true}
                     validate={
                         (actionType !== "Edit" && actionType!=="View") ? composeValidators(required) : undefined  
                       } 
                    component={renderField} // Correct usage of renderField
                    // className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                    className="bg-muted/40 min-h-9 max-h-20 w-full rounded-md text-base border p-2 border-[#3a5dd1] manrope-fontCss placeholder: placeholder: focus:outline-none"
  
                  />
                  {/* Reserve space for the error message */}
                  {meta.touched && meta.error && (
                    <p className="text-red-500 text-sm text-left my-[2px]">&nbsp;{meta.error}</p>
                  )}
                </div>

                {/* <div className="gap-2 flex flex-col w-[49%]">
                  <Label className="text-start text-[#0D215C] font-bold text-lg " htmlFor="no_of_units_issued">NO OF UNITS ISSUED<span className=" text-red-600">*</span> </Label>
                  <Field
                    id="no_of_units_issued"
                    type="text"
                    name="no_of_units_issued"
                    placeholder="No of units issued"
                    actionType={actionType}
                    info={schemeInfo && schemeInfo.no_of_units_issued?schemeInfo.no_of_units_issued:null}
                    disabled={actionType==="View" && true}
                    // validate={composeValidators(required)}
                    component={renderField} // Correct usage of renderField
                    className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                  />
                 
                  {meta.touched && meta.error && (
                    <p className="text-red-500 text-sm text-left my-[2px]">&nbsp;{meta.error}</p>
                  )}
                </div> */}

</div>
              <hr />

              {/* <div className="flex w-full items-center gap-4 ">


              
                <div className="flex flex-col w-[49%] gap-2">
                  <Label htmlFor="aum">Class</Label>
                  
                  <Field
                    id="addClass"
                    name="addClass"
                    placeholder="Add Class"
                    type="text"
                    // validate={composeValidators(required)}
                    component={renderField} // Correct usage of renderField
                    className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                  />
                </div>

                <Button onClick={()=>setAddNewClass(true)} className="w-max bg-[#0D215C] self-end " >
                  Add New Class
                </Button>

              </div>

              {addNewClass &&
                <div className="flex w-full items-center gap-4 ">

                  <div className="gap-4 w-[49%]">
                    <Field
                      id="newClass"
                      name="newClass"
                      placeholder="New Class"
                      type="text"
                      validate={composeValidators(required)}
                      component={renderField} // Correct usage of renderField
                      className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                    />
                 
                    {meta.touched && meta.error && (
                      <p className="text-red-500 text-sm text-left my-[2px]">&nbsp;{meta.error}</p>
                    )}
                  </div>

                  <Button className="w-max bg-[#0D215C] " >
                    Add Class
                  </Button>

                </div>
              } */}
              
              {/* <DynamicInputFields
        label="Fund Manager"
        name="Fund Manager"
        placeholder="Enter Fund Manager"
        onFieldsChange={handleFieldsChange}
        initialValues={fundManagerArray}
        disabled={actionType==="View" && true}
      /> */}
      <DynamicInputFields
        label="Fund Manager"
        name="Fund Manager"
        placeholder="Enter Fund Manager"
        onFieldsChange={handleFieldsChange}
        initialValues={schemeInfo && schemeInfo.fund_manager}
        disabled={actionType==="View" && true}
      />

             {actionType!=="View" && <Button type="submit" className="w-max bg-[#0D215C] self-end " >
               { actionType==="Edit"? "Save Changes": " Create Scheme"}
              </Button>}
                
            </div>

          </form>
        )}
      />





    </Card>
  )
}

export default NewSchemaForm